import { useCallback } from 'react';

import { useNavigation } from '@react-navigation/native';
import { StackNavigationProp } from '@react-navigation/stack';

import { PlayerWithTeamAndEvent } from '@/feature/betslip-pickem/types';
import { usePlayerProfileDataStore } from '@/feature/player-profile-sheets/hooks/use-player-profile-data-store';
import { RootStackParamList } from '@/navigation/types';

export const useOpenPlayerProfile = (players: PlayerWithTeamAndEvent[]) => {
    const setPlayersList = usePlayerProfileDataStore(state => state.actions.setPlayersList);
    const setSelectedPlayerIndex = usePlayerProfileDataStore(state => state.actions.setSelectedPlayerIndex);
    const setSelectedPlayerProjectionFilter = usePlayerProfileDataStore(
        state => state.actions.setSelectedPlayerProjectionFilter
    );
    const navigation = useNavigation<StackNavigationProp<RootStackParamList>>();

    const openPlayerProfile = useCallback(
        (playerId: string, playerProjectionFilter?: string) => {
            const index = players.findIndex(player => player.id === playerId) ?? 0;
            setSelectedPlayerProjectionFilter(playerProjectionFilter);
            setSelectedPlayerIndex(index || 0);
            setPlayersList(players || []);
            navigation.navigate('PlayerProfileSheets', {
                contextKey: new Date().getTime().toString(),
            });
        },
        [navigation, players, setPlayersList, setSelectedPlayerIndex, setSelectedPlayerProjectionFilter]
    );

    return {
        openPlayerProfile,
    };
};
